import {postData, getData} from 'helpers/apiHelper'
import { MAIN_PATH, LOGIN,APP_PATH,REGISTER, LOGOUT, FORGOT_PASSWORD, RESET_PASSWORD, RESET_PASSWORD_FORM, CHANGE_PASSWORD, ACCOUNT_ACTIVATION, SEND_OTP, RESEND_OTP, SUBMIT_ACCOUNT_DELETE_REQUEST, VERIFY_OTP } from './apiPath'
import { authLogin, authRegister, authLogout, updatePassword, authSendOtp} from 'store/actions/auth';
import { profile } from './profileService';
import { pickBy } from "lodash";

//login
export function login(credentials, callback) {
  return (dispatch) => postData(`${MAIN_PATH}${LOGIN}`, credentials)
    .then((data) => {
      dispatch(authLogin(data, callback));
      return data;
    });
}

//register
export function register_(credentials, callback) {
  return (dispatch) => postData(`${MAIN_PATH}${REGISTER}`, pickBy(credentials))
    .then((data) => {
      dispatch(authRegister(data, callback));
      return data;
    });
}

//logout
export function logout(credentials) {
  return (dispatch) => postData(`${MAIN_PATH}${LOGOUT}`, credentials)
    .then((data) => {
      dispatch(authLogout(data));
      return data;
    });
}

//forgot passord
export function forgotPassword(value) {
  return (dispatch) => postData(`${MAIN_PATH}${FORGOT_PASSWORD}`, value)
    .then((data) => {
      return data;
    });
}


//forgot passord
export function resetPasswordForm(value) {
  return (dispatch) => getData(`${MAIN_PATH}${RESET_PASSWORD_FORM}`, value)
    .then((data) => {
      return data;
    });
}


//forgot passord
export function resetPassword(token, value) {
  console.log(token, "token")
  return (dispatch) => postData(`${MAIN_PATH}${RESET_PASSWORD}/${token}`, value)
    .then((data) => {
      return data;
    });
}


//account activation
export function activateAccount(value) {
  return (dispatch) => postData(`${APP_PATH}${ACCOUNT_ACTIVATION}`, value)
    .then((data) => {
      return data;
    });
}

//change password
export function changePassword(value, callback) {
  return (dispatch) => postData(`${MAIN_PATH}${CHANGE_PASSWORD}`, value)
    .then((data) => {
      dispatch(updatePassword(data, callback));
      dispatch(profile(data, callback))
      return data;
    });
}

// Send otp
export function sendOtp(payload, registrationData, callback) {
  let url = `${MAIN_PATH}${SEND_OTP}`;
  // let url = `http://localhost:3000/dev/auth/otp/send`;
  return (dispatch) => postData(url, payload)
    .then((data) => {
      dispatch(authSendOtp(registrationData, callback));
      return data;
    });
}

// Resend otp
export function resendOtp(payload, callback) {
  let url = `${MAIN_PATH}${RESEND_OTP}`;
  return postData(url, payload);
}

// Verify otp
export function verifyOtp(payload) {
  let url = `${MAIN_PATH}${VERIFY_OTP}`;
  return postData(url, payload);
}

// submit account deletion request
export function submitAccountDeletionRequest(payload) {
  let url = `${MAIN_PATH}${SUBMIT_ACCOUNT_DELETE_REQUEST}`;
  return postData(url, payload);
}